export const COOKIE_CONSENT_KEY = 'cookieConsent';

export const hasCookieConsent = (): boolean => {
  return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
};

export const setCookieConsent = () => {
  localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
};